import { SingleProductQueryResult } from '@repo/sanity/types'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@repo/ui/components/tabs'
import { FunctionComponent } from 'react'
import SizeGuideTable from './SizeGuideTable'

interface Props {
  tables: NonNullable<NonNullable<SingleProductQueryResult>['sizeGuide']>['tables']
}

// todo: inch as default on US website, https://linear.app/supercosmic/issue/MII-335/use-inch-as-default-unit-for-us-size-guides

const SizeGuideUnitsTables: FunctionComponent<Props> = ({ tables }) => {
  const count = (tables || []).length

  return (
    <div>
      {count > 1 && (
        <Tabs defaultValue={tables?.[0]?._key} className='w-full'>
          <TabsList className='gap-3 px-3 text-sm'>
            {tables?.map((table) => (
              <TabsTrigger key={table._key} value={table._key}>
                {table.title}
              </TabsTrigger>
            ))}
          </TabsList>
          {tables?.map((table) => (
            <TabsContent key={table._key} value={table._key}>
              {table?.table && <SizeGuideTable key={table._key} table={table.table} />}
            </TabsContent>
          ))}
        </Tabs>
      )}
      {count === 1 && tables?.[0]?.table && <SizeGuideTable table={tables?.[0]?.table} />}
    </div>
  )
}

export default SizeGuideUnitsTables
